module.exports = __webpack_public_path__ + "static/media/logo.fab5e924.png";